import React from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "../ErrorBoundary";
export class BaseBlock {
    constructor(domId, dataProvider) {
        this.domId = domId;
        this.isActive = false;
        this.component = React.createElement(React.Fragment, null);
        this.dataProvider = dataProvider;
    }
    activate() {
        const domRef = document.getElementById(this.domId);
        if (domRef) {
            this.root = createRoot(domRef);
            const comp = React.createElement(ErrorBoundary, null, this.component);
            this.root.render(comp);
            this.isActive = true;
            this.dataProvider.activate();
        }
        return this;
    }
    deactivate() {
        var _a;
        const domRef = document.getElementById(this.domId);
        if (domRef) {
            (_a = this.root) === null || _a === void 0 ? void 0 : _a.unmount();
            this.isActive = false;
            this.dataProvider.deactivate();
        }
        return this;
    }
}
//# sourceMappingURL=BaseBlock.js.map